module.exports = __webpack_public_path__ + "img/blue-carats.19e07ce4.svg";